import type { LangCode } from '@/lib/i18n/lang';

/** Jezici u kojima ručno održavamo blog metapodatke (ćirilica se generiše iz sr). */
export const BLOG_CORE_LANGS = ['sr', 'en', 'ru', 'tr', 'de'] as const;
export type BlogCoreLang = (typeof BLOG_CORE_LANGS)[number];

export interface BlogPostTranslation {
  title: string;
  metaTitle: string;
  metaDescription: string;
  excerpt: string;
  /** Full article in Markdown; loaded from `content/blog/bodies/{lang}/{slug}.md` at render time. */
}

export interface BlogExternalRef {
  url: string;
  label: Record<LangCode, string>;
}

/** Sirovi unos u posts.ts pre dodavanja sr-cyrl. */
export interface BlogPostRaw {
  slug: string;
  published: string;
  modified: string;
  readMinutes: number;
  /** Relativna putanja cover slike, npr. `/images/blog/slug.jpg`. Ako nema, koristi se default po slug-u. */
  coverImage?: string;
  translations: Record<BlogCoreLang, BlogPostTranslation>;
  relatedSlugs: string[];
  externalRefs: { url: string; label: Record<BlogCoreLang, string> }[];
}

export interface BlogPost {
  slug: string;
  published: string;
  modified: string;
  readMinutes: number;
  coverImage?: string;
  translations: Record<LangCode, BlogPostTranslation>;
  relatedSlugs: string[];
  externalRefs: BlogExternalRef[];
}

/** Cover putanja za listu i članak. */
export function blogCoverSrc(post: { slug: string; coverImage?: string }): string {
  return post.coverImage ?? `/images/blog/${post.slug}.jpg`;
}
